module.exports = __webpack_public_path__ + "img/microOfficialWebsite.20caa422.png";